import { Component, EventEmitter, HostListener, Output, inject, signal } from '@angular/core';
import {
  I18nService,
  AVAILABLE_LANGUAGES,
  LanguageType,
} from '../../shared/i18n/i18n.service';
import { DropdownMenuComponent } from './dropdown-menu/dropdown-menu-component';
import { PlantSwitcherComponent } from './plant-switcher/plant-switcher';
import { EnvironmentBadge } from '../environment-badge/environment-badge';
import { ProjectService } from '../../shared/services/project/project.service';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { SessionService } from '../../shared/services/session/session.service';

@Component({
  selector: 'app-topbar',
  imports: [
    DropdownMenuComponent,
    PlantSwitcherComponent,
    MatIcon,
    EnvironmentBadge,
  ],
  templateUrl: './topbar.html',
  styleUrl: './topbar.scss',
})
export class Topbar {
  @Output() menuToggle = new EventEmitter<void>();

  protected readonly projectService = inject(ProjectService);
  protected readonly i18n = inject(I18nService);
  protected readonly lang = this.i18n.lang;
  protected readonly AVAILABLE_LANGUAGES = AVAILABLE_LANGUAGES;
  protected readonly router = inject(Router);
  protected readonly sessionService = inject(SessionService);

  protected plantSwitcherOpen = signal(false);

  togglePlantSwitcher(event: MouseEvent): void {
    event.stopPropagation();
    this.plantSwitcherOpen.update((v) => !v);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.topbar__plant-switcher-wrapper')) {
      this.plantSwitcherOpen.set(false);
    }
  }

  setLanguage(lang: LanguageType): void {
    this.sessionService.updateUserLanguage(lang);
  }

  navigateToHome() {
    this.router.navigate(['/plants']);
  }
}
